export const isOnlyTargetAssignment = (
  targetSkillId?: string | null,
  skillAssignments?: string[] | undefined[] | null,
) => skillAssignments?.every(id => targetSkillId === id);
